import { z } from "zod";

export const CycleSchema = z
  .object({
    id: z.string().optional(),
    startDate: z.any().optional(),
    endDate: z.any().optional(),
    flashOutDate: z.any().optional(),
  })
  .passthrough();

export const GoldStreamPlatformSchema = z
  .object({
    totalDeposits: z.any().nullable().optional(),
    totalMatchings: z.any().nullable().optional(),
  })
  .passthrough();

export const GoldStreamWalletSchema = z
  .object({
    id: z.string().optional(),
    investAmount: z.string().optional(),
    gGold: z.string().optional(),
    dailyProfit: z.string().optional(),
    profitCanWithdraw: z.string().optional(),
    matchingReward: z.string().optional(),
    address: z.string().optional(),
    createdAt: z.any().optional(),
    investUpdatedAt: z.any().optional(),
  })
  .passthrough();

export const GoldStreamUserSchema = z
  .object({
    wallet: GoldStreamWalletSchema.optional(),
    reward: z.any().nullable().optional(),
    completedMatchings: z.number().nullable().optional(),
    totalBalanceInTree: z.number().nullable().optional(),
    totalMatchingInTree: z.number().nullable().optional(),
    totalRewardInTree: z.number().nullable().optional(),
  })
  .passthrough();

export const GoldStreamDataSchema = z
  .object({
    cycle: CycleSchema.optional(),
    platform: GoldStreamPlatformSchema.optional(),
    user: GoldStreamUserSchema.optional(),
  })
  .passthrough();

export const GoldStreamResponse = z
  .object({
    data: GoldStreamDataSchema.optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const GoldStreamHistoryTotalSchema = z
  .object({
    matchingCycles: z.number().optional(),
    eachMatchingReward: z.number().optional(),
    totalRewardAllocation: z.number().optional(),
  })
  .passthrough();

export const GoldStreamHistoryDataSchema = z
  .object({
    total: GoldStreamHistoryTotalSchema.optional(),
    history: z.array(z.any()).optional(),
  })
  .passthrough();

export const GoldStreamHistoryResponse = z
  .object({
    data: GoldStreamHistoryDataSchema.optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export default GoldStreamResponse;
